var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';
import Avatar from '../../base/Avatar';
import Button from '../../base/Button';
import Card, { CardBody, CardFooter, CardHeader, CardSubtitle, CardTitle } from '../../base/Card';
import Icon from '../../base/Icon';
import ListView, { ListViewHeader } from '../../base/ListView';
import Loader from '../../base/Loader';
import Popup from '../../base/Popup';
import Typography from '../../base/Typography';
var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        padding: 0 0.5rem;\n\n        &.k-focus::before,\n        &:focus::before,\n        &:hover::before {\n            opacity: 0;\n        }\n\n        .k-avatar-solid-secondary:hover {\n            background-color: ", "\n        }\n    "])), props.theme.component.secondaryHover));
var StyledCard = styled(Card)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n\n    .k-card-footer {\n        border: none;\n        text-align: center;\n    }\n"])), props => css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        .k-card-header {\n            border-width: 0;\n            text-align: center;\n\n            .k-card-title {\n                .k-avatar {\n                    margin-right: 0;\n                }\n            }\n\n            .k-card-subtitle {\n                color: ", ";\n                font-size: medium;\n                font-style: italic;\n\n                div.email {\n                    font-style: normal;\n                    font-weight: 400;\n                }\n            }\n        }\n\n        .k-card-body {\n            padding: 0 1rem;\n\n            .k-listview {\n                border-width: 0;\n\n                .k-listview-content {\n                    .list-item {\n                        padding: 0.5rem 0;\n\n                        &.border-top {\n                            border-top-color: ", ";\n                            border-top-style: solid;\n                            border-top-width: 1px;\n                        }\n\n                        & > svg {\n                            color: ", ";\n                        }\n                    }\n                }\n            }\n        }\n    "])), props.theme.colors.secondary, props.theme.component.spacer, props.theme.typography.link));
var loadingRender = list => {
  var {
    dataItem
  } = list;
  return dataItem;
};
var accountSettingsHeader = () => /*#__PURE__*/React.createElement(ListViewHeader, null, /*#__PURE__*/React.createElement(Typography, {
  size: "0.875rem",
  type: "title"
}, "Account Settings"));
var linkedAccountsHeader = () => /*#__PURE__*/React.createElement(ListViewHeader, null, /*#__PURE__*/React.createElement(Typography, {
  size: "0.875rem",
  type: "title"
}, "Manage My Linked Accounts"));
var UserAccount = props => {
  var _user$name;
  var {
    accountSettings,
    hideLinkedAccounts,
    linkedAccounts,
    onSignOut,
    show,
    user
  } = props;
  var [internalLinkedAccounts, setInternalLinkedAccounts] = useState(null);
  var [internalShow, setInternalShow] = useState(false);
  var anchor = useRef(null);
  var popup = useRef(null);
  var initials = user === null || user === void 0 ? void 0 : (_user$name = user.name) === null || _user$name === void 0 ? void 0 : _user$name.split(' ').map(word => word[0]).slice(0, 2).join('').toUpperCase();
  var itemRender = list => {
    var {
      dataItem,
      index
    } = list;
    if (dataItem.visible) {
      return /*#__PURE__*/React.createElement("div", {
        className: "list-item".concat(index > 0 ? ' border-top' : '')
      }, /*#__PURE__*/React.createElement(Button, {
        disabled: dataItem.disabled,
        onClick: dataItem.onClick ? () => {
          dataItem.onClick();
          setInternalShow(false);
        } : () => {
          window.open(dataItem.url, '_blank');
        },
        variant: "link"
      }, dataItem.icon && /*#__PURE__*/React.createElement(Icon, {
        icon: dataItem.icon,
        style: {
          width: '1.25rem'
        }
      }), /*#__PURE__*/React.createElement("span", {
        style: {
          marginLeft: "".concat(dataItem.icon ? '0.5rem' : '2.25rem'),
          textAlign: 'left'
        }
      }, dataItem.name)));
    }
    return null;
  };
  var handleClick = event => {
    if (anchor.current.contains(event.target) || popup.current.contains(event.target)) {
      return;
    }
    setInternalShow(false);
  };
  useEffect(() => {
    if (!hideLinkedAccounts && linkedAccounts) {
      setInternalLinkedAccounts(linkedAccounts.map(account => _objectSpread(_objectSpread({}, account), {}, {
        icon: account.icon || ['fas', 'sign-in-alt']
      })));
    }
  }, [hideLinkedAccounts, linkedAccounts]);
  useEffect(() => {
    if (internalShow) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [internalShow]);
  useEffect(() => setInternalShow(show), [show]);
  return /*#__PURE__*/React.createElement("div", {
    ref: anchor,
    style: {
      display: 'inline-flex'
    }
  }, /*#__PURE__*/React.createElement(StyledButton, {
    fillMode: "flat",
    onClick: () => setInternalShow(!internalShow),
    themeColor: "secondary"
  }, /*#__PURE__*/React.createElement(Avatar, {
    rounded: "full",
    themeColor: "secondary",
    type: "text"
  }, initials)), /*#__PURE__*/React.createElement(Popup, {
    anchor: anchor.current,
    anchorAlign: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    borderless: true,
    onClose: () => {
      setInternalShow(false);
    },
    popupAlign: {
      horizontal: 'right',
      vertical: 'top'
    },
    show: internalShow
  }, /*#__PURE__*/React.createElement("div", {
    ref: popup
  }, /*#__PURE__*/React.createElement(StyledCard, null, /*#__PURE__*/React.createElement(CardHeader, null, /*#__PURE__*/React.createElement(CardTitle, null, /*#__PURE__*/React.createElement(Avatar, {
    rounded: "full",
    themeColor: "secondary",
    type: "text"
  }, initials)), /*#__PURE__*/React.createElement(CardSubtitle, null, /*#__PURE__*/React.createElement("div", null, user === null || user === void 0 ? void 0 : user.name), /*#__PURE__*/React.createElement("div", {
    className: "email"
  }, user === null || user === void 0 ? void 0 : user.email))), /*#__PURE__*/React.createElement(CardBody, null, accountSettings && /*#__PURE__*/React.createElement(ListView, {
    data: accountSettings,
    header: accountSettingsHeader,
    item: itemRender
  }), !hideLinkedAccounts && /*#__PURE__*/React.createElement(ListView, {
    data: internalLinkedAccounts || [/*#__PURE__*/React.createElement(Loader, {
      style: {
        justifyContent: 'center'
      },
      type: "pulsing"
    })],
    header: linkedAccountsHeader,
    item: internalLinkedAccounts ? itemRender : loadingRender
  })), /*#__PURE__*/React.createElement(CardFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onSignOut,
    themeColor: "primary"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: ['fas', 'sign-out-alt']
  }), /*#__PURE__*/React.createElement("span", null, "Sign Out")))))));
};
UserAccount.defaultProps = {
  accountSettings: undefined,
  hideLinkedAccounts: false,
  linkedAccounts: undefined,
  onSignOut: undefined,
  show: undefined,
  user: undefined
};
UserAccount.propTypes = {
  /**
   * An array of account settings for the component.
   * The possible account settings are:
   * {
   *      disabled: PropTypes.bool,
   *      icon: PropTypes.arrayOf(PropTypes.string),
   *      name: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
   *      onClick: PropTypes.func,
   *      url: PropTypes.string,
   *      visible: PropTypes.bool,
   * }
   */
  accountSettings: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    icon: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func,
    url: PropTypes.string,
    visible: PropTypes.bool
  })),
  /**
   * Controls the visibility of the linked accounts.
   */
  hideLinkedAccounts: PropTypes.bool,
  /**
   * An array of linked account settings for the component.
   * The possible linked account settings are:
   * {
   *      disabled: PropTypes.bool,
   *      icon: PropTypes.arrayOf(PropTypes.string),
   *      name: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
   *      onClick: PropTypes.func,
   *      url: PropTypes.string,
   *      visible: PropTypes.bool,
   * }
   */
  linkedAccounts: PropTypes.arrayOf(PropTypes.shape({
    disabled: PropTypes.bool,
    icon: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
    onClick: PropTypes.func,
    url: PropTypes.string,
    visible: PropTypes.bool
  })),
  /**
   * The function triggered when the Sign Out button is clicked.
   */
  onSignOut: PropTypes.func,
  /**
   *  Controls the Popup visibility.
   */
  show: PropTypes.bool,
  /**
   * The user settings for the component.
   * The possible settings are:
   * {
   *      email: PropTypes.string,
   *      name: PropTypes.string,
   * }
   */
  user: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string
  })
};
export default UserAccount;